import React from 'react';
import {fabric} from 'fabric';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';
import {renderIcon} from '~/common/canvas/renderIcon';
import DeleteIcon from '~library/svg/icons/DeleteIcon.svg';
import {toastAlert} from '~library/atoms/Toast';
import {
  canvasAddTextBordersAndIcons,
  canvasRemoveTextBordersAndIcons,
} from '../customs/text_border';
import {white} from '~libSass/base/_exports.sass';

export const removeControl = ({offsetX} = {}) => {
  const removeObject = (eventData, obj) => {
    const {canvas} = obj.target;
    canvasRemoveTextBordersAndIcons(canvas);
    const allObjects = canvas.getObjects();
    const allActiveObjects = canvas.getActiveObjects();
    const rectObject = allObjects?.find((rectObj) => rectObj.type === 'rect');

    const filterTextBoxes = (arr = []) => arr?.filter((textObj) => textObj?.type === 'textbox');

    const containPicture = allActiveObjects?.some((picObj) => picObj.type !== 'textbox');
    const texts = filterTextBoxes(allObjects);
    const textObjectsToBeRemoved = filterTextBoxes(allActiveObjects);
    const isUyoSticker = allActiveObjects[0]?.id?.indexOf('uyo_sticker') > -1;
    const isSticker =
      allActiveObjects[0]?.originalUrl?.indexOf('sticker_image') > -1 || isUyoSticker;

    if (isSticker || texts.length - textObjectsToBeRemoved.length >= 1) {
      if (containPicture) {
        rectObject?.set({fill: 'rgb(128,128,128,0.5)', type: 'uYOImage'});
        canvas.renderAll();
        canvas.fire('object:modified');
      }
      allActiveObjects?.map((textObj) => canvas.remove(textObj));
      canvas.discardActiveObject();
      canvas.renderAll();
    } else {
      toastAlert('Must have at least 1 text box', {
        type: 'error',
        icon: <AlertLineIcon ratio={0.65} />,
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    canvasAddTextBordersAndIcons(canvas);
  };

  const padding = 9;

  return new fabric.Control({
    x: 0,
    y: -0.5,
    offsetX: offsetX ?? -22,
    offsetY: -16 - padding,
    cursorStyle: 'pointer',
    mouseUpHandler: removeObject,
    render: renderIcon({icon: DeleteIcon, padding, fillStyle: white}),
    cornerSize: 16,
    touchSizeX: 32,
    touchSizeY: 32,
    sizeX: 30,
    sizeY: 30,
  });
};
